import styled from "styled-components";

export const StyledMeta = styled.span`
  color: black;
  font-weight: 300;
  cursor: pointer;
  font-family: open sans, helvetica neue, Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1;
`;

export const shortenMonth = (month) => {
  if (month.length > 3) {
    return month.substring(0, 3);
  }
  return month;
};

export const shortenString = (url) => {
  let length = url.length;
  let maxAllowed = 25;

  if (length >= maxAllowed) {
    return url.substring(0, maxAllowed) + "...";
  }
  return url;
};

export const replaceTextFunction = (resultUrl) => {
  let s3Url = "https://d27i75siv2q3xq.cloudfront.net/";
  let htmlSuffix = ".html";
  if (resultUrl.includes(htmlSuffix) && resultUrl.includes(s3Url)) {
    return resultUrl
      .replace(".html", "")
      .replace("https://d27i75siv2q3xq.cloudfront.net/", "");
  }
  return resultUrl;
};
